import { render, staticRenderFns } from "./OrderNumber.vue?vue&type=template&id=d6a5313e&"
import script from "./OrderNumber.vue?vue&type=script&lang=js&"
export * from "./OrderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports